import React from 'react'
import { Accordion, Header, Container } from 'semantic-ui-react'
import Link from 'next/link'

import SEO from 'lib/components/SEO'
import ExternalLink from 'lib/components/ExternalLink'

const FAQ = ({}) => {
  return (
    <>
      <SEO
        title="Frequently Asked Questions | Recall Monitor"
        description="Frequently Asked Questions about Recall Monitor and its subscription service."
        canonical="https://recallmonitor.ca/faq"
      />
      <Container text css={{ marginTop: '1rem', marginBottom: '1rem' }}>
        <Header
          as="h1"
          subheader="Missing answers? Contact us at contact@recallmonitor.ca"
          content="Frequently Asked Questions"
        />

        {/* <Header>Recall Monitor</Header> */}
        <Accordion
          fluid
          styled
          // defaultActiveIndex={[0, 1, 2]}
          // exclusive={false}
          panels={[
            {
              key: 'what-is-recallmonitor',
              title: 'What is Recall Monitor?',
              content: {
                content: (
                  <p>
                    Recall Monitor watches Recall and Safety Alerts from{' '}
                    <ExternalLink href="http://www.hc-sc.gc.ca/index-eng.php">
                      Health Canada
                    </ExternalLink>
                    ,{' '}
                    <ExternalLink href="http://www.tc.gc.ca/eng/tc-main.htm">
                      Transport Canada
                    </ExternalLink>{' '}
                    and the{' '}
                    <ExternalLink href="http://www.inspection.gc.ca/english/toce.shtml">
                      Canadian Food Inspection Agency
                    </ExternalLink>{' '}
                    and sends you notifications for the products you care about
                    as soon as they are published.
                  </p>
                ),
              },
            },
            {
              key: 'what-notifications',
              title: 'What type of notifications can I receive?',
              content: {
                content: (
                  <p>
                    With a subscription, you can receive either email or SMS
                    notifications. If you have SMS notifications enabled, you
                    will only receive SMS.
                  </p>
                ),
              },
            },
            {
              key: 'filters',
              title: 'Can I filter the notifications that I receive?',
              content: {
                content: (
                  <>
                    <p>
                      Yes! Besides being able to receive notifications for all
                      Recall and Safety alerts, you can pick among 3 different
                      filters to cut down on the noise, and receive only the
                      alerts that you care about
                    </p>
                    <p>
                      You can filter by multiple <strong>Categories</strong>,
                      which will only notify you if an alert comes in matching
                      the Category that you've selected.
                    </p>
                    <p>
                      You can filter by <strong>Alert Types</strong>: for
                      example if you're not interested in "Information Updates",
                      you can exclude it from your settings.
                    </p>
                    <p>
                      Lastly, you can filter by <strong>Keywords</strong>, which
                      Recall Monitor will match against the title of the alert
                      and notify you if there's a match.
                    </p>
                  </>
                ),
              },
            },
            {
              key: 'pricing',
              title: 'How much does it cost?',
              content: {
                content: (
                  <>
                    <p>
                      Recall Monitor operates on a monthly subscription basis.
                      We have different plans depending on your needs, primarily
                      Personal and Corporate. Visit our
                      <Link href="/pricing">
                        <a>Pricing</a>
                      </Link>{' '}
                      page.
                    </p>
                    <p>
                      You can subscribe, or cancel your subscription at any time
                      from your{' '}
                      <Link href="/user">
                        <a>Settings</a>
                      </Link>{' '}
                      page.
                    </p>
                    <p>
                      We do offer time-limited free Personal plans for certain
                      users who are not able to make payments. Please contact{' '}
                      <a href="mailto:contact@recallmonitor.ca">
                        contact@recallmonitor.ca
                      </a>{' '}
                      for more information.
                    </p>
                  </>
                ),
              },
            },
            {
              key: 'data',
              title: 'Where do you get Recall and Safety alerts from?',
              content: {
                content: (
                  <>
                    <p>
                      Recall Monitor gets its data from the Recalls and Safety
                      Alerts dataset, provided by the Government of Canada
                      through the{' '}
                      <ExternalLink href="https://open.canada.ca/en">
                        Open Government
                      </ExternalLink>{' '}
                      initiative and is subject to the{' '}
                      <a
                        href="https://open.canada.ca/en/open-government-licence-canada"
                        target="_blank"
                        rel="noreferrer noopener"
                      >
                        Open Government License
                      </a>
                      .
                    </p>
                    <p>
                      You can access this data free of charge via Recall
                      Monitor, or through the{' '}
                      <ExternalLink href="http://www.healthycanadians.gc.ca/recall-alert-rappel-avis/index-eng.php">
                        Healthy Canadians
                      </ExternalLink>{' '}
                      website. You do not have to pay to access this data.
                    </p>
                  </>
                ),
              },
            },
          ]}
        />
      </Container>
    </>
  )
}

export default FAQ
